import { TextArea } from 'devextreme-react/text-area';
import { formatDate } from 'devextreme/localization';
import { useContext, } from 'react';
import { Link } from 'react-router-dom';
import { Field, Panel } from '../../../../layouts';
import { WorkOrderContext } from '../context/WorkOrderContext';

export default function WorkOrderInformationPanel() {

	const { order } = useContext(WorkOrderContext);

	return (
		<>
			<Panel
				header={'Work Order Information'}
			>
				<Field label={'Order #'} >{order.details.woNumber}</Field>
				<Field label={'Order Status'} >{order.details.orderStatus}</Field>
				<Field label={'Order Date'} >{formatDate(new Date(order.details.woDate), 'shortDate')}</Field>
				<Field label={'Project #'} >{order.details.projectNumber}</Field>
				<Field label={'Originating RO #'} >
					<Link to={'/dealer/retail-order/' + order.details.originatingROID}>
						{order.details.originatingRO}
					</Link>
				</Field>
			</Panel>
		</>
	);
}
